import { useTranslation } from "react-i18next";
import InputCustom from "../../Common/InputCustom/InputCustom";
import SelectCustom from "../../Common/SelectCustom/SelectCustom";
import { useContext, useRef, useState } from "react";
import { Form } from "antd";
import { GlobalContext } from "../../../context/GlobalContext";
import IconButton from "mobily-ui-library/lib/components/composite/iconButton/IconButton";

function DeliveryAddress({ rtl }: any) {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const [isFormValid, setIsFormValid] = useState(false);
  const [state, dispatch]: any = useContext(GlobalContext);
  const { deliveryAddressData, deliveryAddressFieldsTouched } = state;
  const page = t("Download_Attach");
  const regionOptions = [
    {
      text: t("Central"),
      value: "01",
    },
    {
      text: t("Eastern"),
      value: "02",
    },
    {
      text: t("Western"),
      value: "03",
    },
  ];

  const initialValues = {
    city: deliveryAddressData?.city,
    districtName: deliveryAddressData?.district,
    street: deliveryAddressData?.street,
    buildingNo: deliveryAddressData?.buildingNo,
    region: deliveryAddressData?.region,
    shortAddress: deliveryAddressData?.shortAddress
  };

  const onValuesChange = () => {
    console.log("formdata");
    setTimeout(() => {
      setIsFormValid(
        (deliveryAddressFieldsTouched ||
          form.isFieldsTouched(
            ["city", "districtName", "streetName", "buildingNo", "region", "shortAddress"],
            true
          )) &&
        form.getFieldsError().every(({ errors }) => errors.length === 0)
      );
    }, 0);
  };

  const handleDeliveryNext = (values: any) => {
    dispatch({
      type: 'DELIVERY_ADDRESS_DATA',
      payload: {
        values,
        page,
      }
    });
  };

  const onFinishFailed = (errorInfo: any) => {
    const { errorFields } = errorInfo;
    if (errorFields.length > 0 && formRef.current) {
      const firstErrorField = errorFields[0].name[0];
      const firstErrorFieldElement = document.getElementById(
        `${firstErrorField}`
      );
      if (firstErrorFieldElement) {
        firstErrorFieldElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
  };

  return (
    <div>
      <Form
        ref={formRef}
        form={form}
        name="deliveryAddressForm"
        initialValues={initialValues}
        onFinish={handleDeliveryNext}
        onFinishFailed={onFinishFailed}
        onValuesChange={onValuesChange}
      >
        <InputCustom
          rtl={rtl}
          maxLength={120}
          headingleft={t("City")}
          name="city"
          rules={[
            { required: true, message: `${t("Please_Enter")} ${t("City")}` },
          ]}
        />
        <InputCustom
          rtl={rtl}
          maxLength={120}
          headingleft={t("District_Name")}
          name="districtName"
          rules={[
            {
              required: true,
              message: `${t("Please_Enter")} ${t("District_Name")}`,
            },
          ]}
        />
        <InputCustom
          rtl={rtl}
          maxLength={120}
          headingleft={t("Street_Name")}
          name="streetName"
          rules={[
            {
              required: true,
              message: `${t("Please_Enter")} ${t("Street_Name")}`,
            },
          ]}
        />
        <InputCustom
          rtl={rtl}
          maxLength={5}
          headingleft={t("Building_Number")}
          name="buildingNo"
          rules={[
            {
              required: true,
              message: `${t("Please_Enter")} ${t("Building_Number")}`,
            },
            { pattern: /^[0-9]+$/, message: t("Verify_Data") },
          ]}
        />
        <InputCustom
          rtl={rtl}
          maxLength={8}
          headingleft={t("Short_Address")}
          name="shortAddress"
          rules={[
            {
              required: true,
              message: `${t("Please_Enter")} ${t("Short_Address")}`,
            },
            {
              pattern: /^[A-Za-z]{4}[0-9]{4}$/,
              message: t("Short_Address_Validation_Message"),
            },
          ]}
        />

        <SelectCustom
          headingLeft={t("Region")}
          options={regionOptions}
          name="region"
          rules={[
            { required: true, message: `${t("Please_Enter")} ${t("Region")}` },
          ]}
        />
        <div
          className={`form-action ${rtl ? "rtl" : ""}`}
          style={{
            display: "flex",
            justifyContent: rtl ? "flex-end" : "flex-start",
          }}
        >
          <IconButton
            width={"130px"}
            htmlType="submit"
            rtl={rtl}
            className={`next-button ${isFormValid ? "" : "disabled"}${rtl ? "rtl" : ""}`}
          >
            {t("Next")}
          </IconButton>
        </div>
      </Form>
    </div>
  );
}

export default DeliveryAddress;
